/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_No_Round_To_CancelInputs */



/**
* | output |
* | --- |
* | "No rounds to cancel" |
*
* @param {Err_Tournament_No_Round_To_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_no_round_to_cancel = /** @type {((inputs?: Err_Tournament_No_Round_To_CancelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_No_Round_To_CancelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ronde à annuler")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ninguna ronda que cancelar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma rodada para cancelar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun round da annullare")
	return /** @type {LocalizedString} */ ("No rounds to cancel")
});